import { render, staticRenderFns } from "./hdqForm.vue?vue&type=template&id=3072129c&scoped=true"
import script from "./hdqForm.vue?vue&type=script&lang=js"
export * from "./hdqForm.vue?vue&type=script&lang=js"
import style0 from "./hdqForm.vue?vue&type=style&index=0&id=3072129c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072129c",
  null
  
)

export default component.exports